export const filtersConfig = {
    type: {
        operator: 'OR'
    },
    category_uuid: {
        operator: 'AND'
    },
    cooking_type_uuid: {
        operator: 'OR'
    },
    field_difficulty: {
        operator: 'OR'
    },
    field_price_indicator: {
        operator: 'OR'
    },
    season_uuid: {
        operator: 'AND'
    },
    field_production_time_slice: {
        operator: 'OR'
    },
    field_resting_time_slice: {
        operator: 'OR'
    },
    field_tags: {
        operator: 'AND'
    },
    ingredient_uuid: {
        operator: 'AND'
    },
}